if (typeof customElements.get('announcement-bar') === 'undefined') {
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = [...this.querySelectorAll('.announcement')];
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');
      this.index = 0;
      this.length = this.content.length;
      this.interval = Number(this.dataset.interval) || 5000;
      this.autoRotate = this.dataset.autoRotate === 'true';
      this.rotationTimer = null;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.handleNext = () => this.changeSlide('next', true);
      this.handlePrevious = () => this.changeSlide('prev', true);
      this.handleVisibility = () => {
        if (document.hidden) this.stopRotation();
        else this.startRotation();
      };
    }

    connectedCallback() {
      if (!this.slider || this.length < 2) return;

      this.nextButton?.addEventListener('click', this.handleNext);
      this.prevButton?.addEventListener('click', this.handlePrevious);
      this.addEventListener('pointerenter', this.stopRotation);
      this.addEventListener('pointerleave', this.startRotation);
      this.addEventListener('focusin', this.stopRotation);
      this.addEventListener('focusout', this.startRotation);
      document.addEventListener('visibilitychange', this.handleVisibility);

      this.updateSlide(false);
      this.startRotation();
    }

    disconnectedCallback() {
      this.stopRotation();
      this.nextButton?.removeEventListener('click', this.handleNext);
      this.prevButton?.removeEventListener('click', this.handlePrevious);
      this.removeEventListener('pointerenter', this.stopRotation);
      this.removeEventListener('pointerleave', this.startRotation);
      this.removeEventListener('focusin', this.stopRotation);
      this.removeEventListener('focusout', this.startRotation);
      document.removeEventListener('visibilitychange', this.handleVisibility);
    }

    changeSlide(direction, userInitiated = false) {
      const increment = direction === 'prev' ? -1 : 1;
      this.index = (this.index + increment + this.length) % this.length;
      this.updateSlide(true);

      if (userInitiated) {
        this.stopRotation();
        this.startRotation();
      }
    }

    updateSlide(animate) {
      this.content.forEach((slide, slideIndex) => {
        const isCurrent = slideIndex === this.index;
        slide.setAttribute('aria-hidden', String(!isCurrent));
        slide.querySelectorAll('a, button').forEach((control) => {
          if (isCurrent) control.removeAttribute('tabindex');
          else control.setAttribute('tabindex', '-1');
        });
      });

      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft - this.content[0].offsetLeft,
        behavior: animate && !this.reducedMotion.matches ? 'smooth' : 'auto'
      });
    }

    startRotation = () => {
      if (!this.autoRotate || this.length < 2 || this.reducedMotion.matches || document.hidden) return;
      this.stopRotation();
      this.rotationTimer = window.setInterval(() => this.changeSlide('next'), this.interval);
    };

    stopRotation = () => {
      if (!this.rotationTimer) return;
      window.clearInterval(this.rotationTimer);
      this.rotationTimer = null;
    };
  }

  customElements.define('announcement-bar', AnnouncementBar);
}
